import { render, staticRenderFns } from "./commonBottomButton.vue?vue&type=template&id=09eb8284&scoped=true"
import script from "./commonBottomButton.vue?vue&type=script&lang=js"
export * from "./commonBottomButton.vue?vue&type=script&lang=js"
import style0 from "./commonBottomButton.vue?vue&type=style&index=0&id=09eb8284&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09eb8284",
  null
  
)

export default component.exports